import defaultStorePlugin from 'store/plugins/defaults';
import cleanUpPlugin from './controllers/storage-cleanup-plugin/index.tsx';
import type { Storage } from './types.tsx';

export const plugins = [defaultStorePlugin, cleanUpPlugin];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createStorageProvider = (appPrefix: string, store: any): Storage =>
	store.namespace(appPrefix);
